// Save-billing choice restoration (slice 2.6, D-010 scope extension): the
// legacy Angular attach checkbox defaulted ON and fired
// POST /billing/toggle-save at attach; the React messenger lost that write
// path in January. This module holds the kill lever and the redirect-resume
// persistence for the entry-mode checkbox value.

// Kill lever: in-code ON; env SAVE_BILLING_CHOICE_ENABLED="false"/"0"
// disables both surfaces and every toggle-save write.
export const saveBillingChoiceEnabled = (): boolean => {
  try {
    const v = (window as any)?.Penmate?.env?.saveBillingChoiceEnabled;
    if (typeof v === "string" && v.trim()) {
      const s = v.trim().toLowerCase();
      return s !== "false" && s !== "0";
    }
    return true;
  } catch {
    return true;
  }
};

// A Cash App (or any redirect-based) attach leaves the page before the
// checkbox value can be applied, so the choice rides along in sessionStorage
// keyed by the Stripe checkout session id. Missing or unreadable → ON, the
// legacy default.
const choiceStorageKey = (sessionId: string): string => `pmreact:save-billing-choice:${sessionId}`;

export const storeSaveBillingChoice = (sessionId: string, save: boolean): void => {
  try {
    window.sessionStorage.setItem(choiceStorageKey(sessionId), save ? "1" : "0");
  } catch {
    // Storage unavailable: resume falls back to the default-ON path.
  }
};

export const readSaveBillingChoice = (sessionId: string): boolean => {
  try {
    return window.sessionStorage.getItem(choiceStorageKey(sessionId)) !== "0";
  } catch {
    return true;
  }
};

export const clearSaveBillingChoice = (sessionId: string): void => {
  try {
    window.sessionStorage.removeItem(choiceStorageKey(sessionId));
  } catch {
    // ignore
  }
};
